/* =========================================================
   XNOVATE V10 — 5 SIGNATURE MOMENTS
   Chargé après xnovate-animations.js. Fallback reduced-motion.
   Dépend de : gsap, ScrollTrigger, SplitText, DrawSVGPlugin,
               MorphSVGPlugin (implicit via DrawSVG), ScrambleTextPlugin, Flip.
   ========================================================= */
(function () {
  'use strict';

  function reducedMotion() {
    return document.documentElement.dataset.reducedMotion === 'true';
  }

  /* ---- MOMENT 1 — DEPRECATED V10.1 ----
     Hero headline/tagline/CTAs sont maintenant gérés par xnovate-animations.js
     avec une animation word-reveal conforme au brief §5.1 (stagger 0.06s,
     duration 0.9s, power3.out). Blade sweep migré là aussi. */
  function signatureBladeReveal() {
    return; /* no-op, conserved for backward-compat calls */
  }

  /* ---- MOMENT 2 — Ignition (keynova card + product hero) ---- */
  function signatureIgnition() {
    var cards = document.querySelectorAll('[data-xn-signature="ignition"]');
    cards.forEach(function (card) {
      var framePaths = card.querySelectorAll('.xn-frame-stroke');
      var corners = card.querySelectorAll('.xn-frame-corner');
      var media = card.querySelector('.xn-keynova-frame__media');
      var title = card.querySelector('[data-text]');
      if (framePaths.length === 0) return;

      gsap.set(framePaths, { drawSVG: '0%' });
      gsap.set(corners, { opacity: 0, scale: 0.5, transformOrigin: 'center center' });
      if (media) gsap.set(media, { opacity: 0 });

      // V10.5 — FIX B5 : toggleActions 'play none none none' + once:true
      // pour que la photo Keynova ne disparaisse plus si l'utilisateur sort
      // et revient sur la section. onComplete force l'opacity finale.
      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: card,
          start: 'top 70%',
          toggleActions: 'play none none none',
          once: true
        }
      });

      tl.to(framePaths, { drawSVG: '0% 100%', duration: 0.8, stagger: 0.05, ease: 'power2.out' })
        .to(corners, { opacity: 1, scale: 1, duration: 0.3, stagger: 0.08, ease: 'back.out(2)' }, '-=0.2')
        .to(framePaths, { stroke: '#FFFFFF', duration: 0.4 }, '+=0.2');

      if (media) tl.to(media, {
        opacity: 1,
        duration: 0.6,
        ease: 'power2.out',
        onComplete: function () {
          gsap.set(media, { opacity: 1 });
        }
      }, '-=0.2');

      if (title && title.dataset.text && typeof gsap.plugins.ScrambleTextPlugin !== 'undefined') {
        tl.to(title, {
          duration: 1.2,
          scrambleText: {
            text: title.dataset.text,
            chars: 'XNV0123456789/-',
            revealDelay: 0.2,
            speed: 0.4
          }
        }, '-=1');
      }
    });
  }

  /* ---- MOMENT 3 — Bascule blanche + Flip clip-path ---- */
  function signatureFlipBascule() {
    var flipTarget = document.querySelector('[data-xn-flip="apps"]');
    if (!flipTarget) return;
    if (!CSS.supports('clip-path', 'polygon(0 0, 0 0, 0 0, 0 0)')) return;

    ScrollTrigger.create({
      trigger: flipTarget,
      start: 'top bottom',
      end: 'top 30%',
      scrub: 0.6,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        var p = self.progress;
        var offset = (1 - p) * 120;
        flipTarget.style.clipPath = 'polygon(' + (offset - 20) + '% 0, 100% 0, 100% 100%, ' + offset + '% 100%)';
      }
    });
  }

  /* V12.9.1 (CP2) — MOMENT 4 Handwriting (founder + vision) retire.
     La fonction signatureHandwriting() ciblait [data-xn-signature="handwriting"]
     + .xn-signature-path + .xn-signature-dot — tous orphelins suite au retrait
     definitif de la signature manuscrite du founder (decision Osayan). */

  /* ---- MOMENT 5 — V10.1 Respiration Loop (8s cycle, brief §6.3) ----
     Phase 1 (0-2s): Draw-on lines stagger
     Phase 2 (2-5s): Hold full
     Phase 3 (5-7s): Dissolve lines stagger
     Phase 4 (7-8s): Pause before cycle restart
     Halo: pulsation independante opacity 0.3-0.5 scale 1-1.1 sur 4s infinite */
  function signatureAssembly() {
    var xNodes = document.querySelectorAll('[data-xn-signature="assembly"]');
    xNodes.forEach(function (xNode) {
      var lines = xNode.querySelectorAll('.xn-destructured__line');
      var dot = xNode.querySelector('.xn-destructured__dot');
      var halo = xNode.querySelector('.xn-destructured__halo');
      if (lines.length === 0) return;

      // Halo pulsation continue (independant)
      if (halo) {
        gsap.set(halo, { opacity: 0.3, scale: 1 });
        gsap.to(halo, {
          opacity: 0.5,
          scale: 1.1,
          duration: 2,
          ease: 'sine.inOut',
          repeat: -1,
          yoyo: true
        });
      }

      // Master cycle timeline (8s, repeat infinite)
      var cycle = gsap.timeline({ repeat: -1, paused: true });

      // Phase 0: Reset instant
      cycle.set(lines, { opacity: 0, drawSVG: '0%' });
      if (dot) cycle.set(dot, { opacity: 0, scale: 0 });

      // Phase 1: Draw on (0-2s)
      cycle.set(lines, { opacity: 1 }, 0.05);
      lines.forEach(function (line, i) {
        cycle.fromTo(line,
          { drawSVG: '0%' },
          { drawSVG: '0% 100%', duration: 1.2, ease: 'power2.out' },
          0.1 + 0.15 * i
        );
      });
      if (dot) cycle.to(dot, { opacity: 1, scale: 1, duration: 0.4, ease: 'back.out(2)' }, 1.7);

      // Phase 2: Hold (2-5s) — empty pad
      cycle.to({}, { duration: 3 }, 2);

      // Phase 3: Dissolve (5-7s)
      lines.forEach(function (line, i) {
        cycle.to(line,
          { drawSVG: '100% 100%', duration: 1.4, ease: 'power1.in' },
          5 + 0.1 * i
        );
      });
      if (dot) cycle.to(dot, { opacity: 0, scale: 0.5, duration: 0.8 }, 5.5);

      // Phase 4: Pause (7-8s)
      cycle.to({}, { duration: 1 }, 7);

      // Start on scroll into view
      if (xNode.dataset.loop === 'true') {
        ScrollTrigger.create({
          trigger: xNode,
          start: 'top 80%',
          once: true,
          onEnter: function () { cycle.play(); }
        });
      } else {
        ScrollTrigger.create({
          trigger: xNode,
          start: 'top 75%',
          once: true,
          onEnter: function () { cycle.play(); }
        });
      }
    });
  }

  /* ---- Init exposé pour orchestration depuis xnovate-animations.js ---- */
  window.initXnovateSignatureMoments = function () {
    if (reducedMotion()) return;
    if (typeof gsap === 'undefined') return;
    try { signatureBladeReveal(); } catch (e) { console.warn('[xn] Blade', e); }
    try { signatureIgnition(); } catch (e) { console.warn('[xn] Ignition', e); }
    try { signatureFlipBascule(); } catch (e) { console.warn('[xn] Flip', e); }
    /* V12.9.1 (CP2) — appel signatureHandwriting() retire (signature founder supprimee). */
    try { signatureAssembly(); } catch (e) { console.warn('[xn] Assembly', e); }
  };
})();
